import React, { ReactNode, useMemo, useState } from 'react';
import dayjs from 'dayjs';

import { FormComponent, UiComponent } from 'components';
import { usePageOption } from 'hooks';
import { EventQuery } from 'queries';
import { IEvent, SearchEventFilterType } from 'types';
import * as PickerStyle from './style';

const COLS: string[] = ['봉사명', '시작일', '선택'];

interface Props {
  onSelect: (event: IEvent) => void;
}

function EventSelect({ onSelect }: Props) {
  const { pageOption, handlePage } = usePageOption(10);
  const [filter, setFilter] = useState<SearchEventFilterType>({});

  const { data } = EventQuery.useGetAll({
    page: pageOption.page,
    size: pageOption.size,
    ...filter,
  });

  const handleSearch = (d: SearchEventFilterType) => {
    setFilter({ title: d.title?.trim() || undefined });
    handlePage({ ...pageOption, page: 1 });
  };

  const renderer: Record<
    (typeof COLS)[number],
    (data: IEvent & { row: number }) => ReactNode
  > = useMemo(
    () => ({
      봉사명: ({ title }: IEvent) => <p css={{ textAlign: 'left' }}>{title}</p>,
      시작일: ({ startDate }: IEvent) => (
        <>{startDate ? dayjs(startDate).format('YYYY-MM-DD') : '-'}</>
      ),
      선택: (event: IEvent) => (
        <UiComponent.Button
          variant="contained"
          color="primary"
          onClick={() => onSelect(event)}
        >
          선택
        </UiComponent.Button>
      ),
    }),
    [onSelect],
  );

  const rows = (data?.data || []).map((e: IEvent) => ({ ...e, rowKey: e.id }));

  return (
    <>
      <FormComponent.Form css={PickerStyle.searchRow} submit={handleSearch}>
        <FormComponent.SearchInput
          name="title"
          placeholder="봉사명으로 검색해주세요"
          css={{ width: '100%' }}
        />
      </FormComponent.Form>
      <div css={PickerStyle.listWrap}>
        <UiComponent.Table
          cols={COLS}
          renderer={renderer}
          data={rows}
          sticky
          empty="검색 결과가 없습니다"
        />
      </div>
      <UiComponent.Pagination
        pageOption={pageOption}
        handlePage={handlePage}
        totalPage={data?.totalPages || 1}
      />
    </>
  );
}

export default EventSelect;
